
import React from "react";
import { useIsMobile } from "@/hooks/use-mobile";
import { SidebarTrigger, useSidebar } from "@/components/ui/sidebar";
import { Menu } from "lucide-react";

interface PageHeaderProps {
  pageTitle: string;
}

const PageHeader = ({ pageTitle }: PageHeaderProps) => {
  const isMobile = useIsMobile();
  const { isCollapsed } = useSidebar();

  return (
    <div 
      className="flex items-center p-4 border-b bg-white shadow-sm sticky top-0 z-10"
      style={{ 
        position: 'sticky',
        zIndex: 40,
        pointerEvents: 'auto'
      }}
    >
      <SidebarTrigger 
        className={isMobile ? "p-2" : ""}
        showIcon={true}
        style={{ 
          pointerEvents: 'auto',
          position: 'relative',
          zIndex: 50,
          touchAction: 'auto'
        }}
      />
      <h1 
        className={`${isMobile ? "ml-2 text-lg" : "ml-4 text-xl"} font-semibold text-black`}
      >
        {pageTitle}
      </h1>
    </div>
  );
};

export default PageHeader;
